/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_FULL_FEATURE } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IPresentationsModalMethods extends IPluginMethodMap {
  getPresentationsModalProps(args: any): Promise<any>;
}

export class PresentationsModalService implements IAgentPlugin {
  readonly methods: IPresentationsModalMethods;

  constructor() {
    this.methods = {
      getPresentationsModalProps: this.getPresentationsModalProps.bind(this),
    };
  }

  async getPresentationsModalProps(args: any) {
    const graphqlModule = getGraphQLModule();

    const client = graphqlModule.getClient("graphql-gateway");

    const presentationId = args?.presentationId || args?.presentation;

    /*
     * Do not call the feature inventory API until the user
     * selects a presentation.
     */
    if (!client || !presentationId) {
      return {
        features: [],
        commonFeatures: [],
        sectionSpecificFeatures: [],
      };
    }

    try {
      const res = await client.query({
        query: GET_FULL_FEATURE,
        variables: {
          filters: {
            presentationId: {
              eq: presentationId,
            },
          },
        },
        fetchPolicy: "network-only",
      });

      const content =
        res?.data?.getFullCostumeFeatureInventories?.content || [];

      const features = content.map((item: any) => ({
        id: item?.id,
        name: item?.name,
        isCommon: item?.isCommon === true,
        presentation: {
          id: item?.presentation?.id,
          name: item?.presentation?.name,
        },
      }));

      return {
        features,

        commonFeatures: features.filter((item: any) => item?.isCommon === true),

        sectionSpecificFeatures: features.filter(
          (item: any) => item?.isCommon === false,
        ),
      };
    } catch (err: any) {
      console.log("error fetching feature inventory options", err);

      throw err;
    }
  }
}
